
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stranky/[strankaSlug]",
      function () {
        return require("private-next-pages/stranky/[strankaSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stranky/[strankaSlug]"])
      });
    }
  